export default {
    TABAGISMO: 1,
    ETILISMO: 2,
    OBESIDADE: 3,
    PERFIL_SANGUINEO_ALTERADO: 4,
    CANCER: 5,
    USO_MEDICAMENTOS_ANTINEOPLASICOS_IMUNOSSUPRESSORES: 6,
    RADIOTERAPIA: 7,
    HAS: 8,
    DIABETES: 9,
    OUTRO: 10,
    GESTANTE: 11,
}